export const PASSO_INICIAL = 0;                 //SITUACAO_NAO_EXECUTADA
export const PASSO_LOADING = 1;                 //SITUACAO_NAO_EXECUTADA
export const PASSO_ERRO_INICIALIZAR_SDK = 2;    //SITUACAO_ERRO_SISTEMA
export const PASSO_TELA_INICIAL = 3;            //SITUACAO_NAO_EXECUTADA
export const PASSO_INSTRUCOES = 4;              //SITUACAO_NAO_EXECUTADA
export const PASSO_INICIANDO_SESSAO = 5;        //SITUACAO_NAO_EXECUTADA
export const PASSO_VERIFICANDO_STATUS = 6;      //SITUACAO_NAO_EXECUTADA
export const PASSO_CONCLUIDO = 7;               //SITUACAO_EXECUTADA_SUCESSO
export const PASSO_CAMERA_NAO_HABILITADA = 8;   //SITUACAO_EXECUTADA_SUCESSO
export const PASSO_ERRO = 9;                    //SITUACAO_EXECUTADA_REPROVADA, SITUACAO_SEM_DADOS, SITUACAO_LIVENESS_REPROVADO
export const PASSO_LOGIN_BANCO = 10;            //SITUACAO_SEM_DADOS
export const PASSO_PDF_INSTRUCOES_DOWNLOAD_SUCESSO = 11;
export const PASSO_PDF_INSTRUCOES_DOWNLOAD_ERRO = 12;

export const SITUACAO_NAO_EXECUTADA = 0;
export const SITUACAO_EXECUTADA_REPROVADA = 1;
export const SITUACAO_EXECUTADA_SUCESSO = 2;
export const SITUACAO_SEM_DADOS = 3; // Não tem biometria no TSE
export const SITUACAO_LIVENESS_REPROVADO = 4;
export const SITUACAO_OBITO = 5;
export const SITUACAO_ERRO_SISTEMA = 6;
export const SITUACAO_BANCO = 99;

export const FACETEC_EM_PROCESSAMENTO = 0;
export const FACETEC_PROCESSADA = 1;
export const FACETEC_EM_INVESTIGACAO = 2;
export const FACETEC_AGUARDANDO_DOCUMENTO = 3;

export const FACETEC_STATUS = {
  /**
   * The Session was performed successfully and a FaceScan was generated.  Pass the FaceScan to the Server for further processing.
   */
  SessionCompletedSuccessfully: 0,
  /**
   * The Session was cancelled because not all guidance images were configured.
   */
  MissingGuidanceImages: 1,
  /**
   * The Session was cancelled because the user was unable to complete a Session in the default allotted time or the timeout set by the developer.
   */
  Timeout: 2,
  /**
   * The Session was cancelled due to the app being terminated, put to sleep, an OS notification, or the app was placed in the background.
   */
  ContextSwitch: 3,
  /**
   * The developer programmatically called the Session cancel API.
   */
  ProgrammaticallyCancelled: 4,
  /**
   * The Session was cancelled due to a device orientation change during the Session.
   */
  OrientationChangeDuringSession: 5,
  /**
   * The Session was cancelled because device is in landscape mode.
   * The user experience of devices in these orientations is poor and thus portrait is required.
   */
  LandscapeModeNotAllowed: 6,
  /**
   * The user pressed the cancel button and did not complete the Session.
   */
  UserCancelled: 7,
  /**
   * The user pressed the cancel button during New User Guidance.
   */
  UserCancelledFromNewUserGuidance: 8,
  /**
   * The user pressed the cancel button during Retry Guidance.
   */
  UserCancelledFromRetryGuidance: 9,
  /**
   * The user cancelled out of the the FaceTec Browser SDK experience while attempting to get camera permissions.
   */
  UserCancelledWhenAttemptingToGetCameraPermissions: 10,
  /**
   * The Session was cancelled because the user was in a locked out state.
   */
  LockedOut: 11,
  /**
   * The Session was cancelled because camera was not enabled.
   */
  CameraNotEnabled: 12,
  /**
   * This status will never be returned in a properly configured or production app.
   * This status is returned if your Key is invalid or network connectivity issues occur during a session when the application is not in production.
   */
  NonProductionModeDeviceKeyIdentifierInvalid: 13,
  /**
   * The Session was cancelled because the FaceTec Browser SDK cannot be rendered when the document is not ready.
   */
  DocumentNotReady: 14,
  /**
   * The Session was cancelled because there was another Session in progress.
   */
  SessionInProgress: 15,
  /**
   * The Session was cancelled because the selected camera is not active.
   */
  CameraNotRunning: 16,
  /**
   * The Session was cancelled because initialization has not been completed yet.
   */
  InitializationNotCompleted: 17,
  /**
   * The Session was cancelled because of an unknown and unexpected error.  The FaceTec Browser SDK leverages a variety of platform APIs including camera, storage, security, networking, and more.
   * This return value is a catch-all for errors experienced during normal usage of these APIs.
   */
  UnknownInternalError: 18,
  /**
   * The Session cancelled because user pressed the Get Ready screen subtext message.
   * Note: This functionality is not available by default, and must be requested from FaceTec in order to enable.
   */
  UserCancelledViaClickableReadyScreenSubtext: 19,
  /**
  * The Session was cancelled, the FaceTec Browser SDK was opened in an Iframe without an Iframe constructor.
  */
  NotAllowedUseIframeConstructor: 20,
  /**
  * The Session was cancelled, the FaceTec Browser SDK was not opened in an Iframe with an Iframe constructor.
  */
  NotAllowedUseNonIframeConstructor: 21,
  /**
  * The Session was cancelled, the FaceTec Browser SDK was not opened in an Iframe without permission.
  */
  IFrameNotAllowedWithoutPermission: 22,
  /**
  * FaceTec SDK is still loading resources.
  */
  StillLoadingResources: 23,
  /**
  * FaceTec SDK could not load resources.
  */
  ResourcesCouldNotBeLoadedOnLastInit: 24,
  /**
  * The Session was cancelled because a full screen mode change was detected in an IFrame
  */
  UserCancelledFullScreenMode: 25
}

export const SERVICO_BIOMETRIA = {
  PROVA_DE_VIDA: 'prova-vida',
  DESBLOQUEIO_EMPRESTIMO_CONSIGNADO: 'desbloqueio-emprestimo-consignado',
  DESBLOQUEIO_MENSALIDADE_ENTIDADE: 'desbloqueio-mensalidade',
  ALTERAR_PAGAMENTO: 'alterar-forma-pagamento'
}

export const BIOMETRIA_PROVIDER_ENUM = {
  "OZ": 0,
  "FACETEC": 1
}

export const INSTRUCAO_LUMINOSIDADE = 'Escolha um ambiente iluminado e sem pessoas ao fundo.'
export const INSTRUCAO_ROSTO = 'Deixe o rosto bem visível. Evite chapéu, óculos de sol ou qualquer coisa que cubra o rosto.'
export const INSTRUCAO_CELULAR = 'Mantenha a câmera do celular, tablet ou computador na altura do rosto. Use a câmera da frente no celular e tablet.'
export const INSTRUCAO_FRAME = 'Mantenha todo o rosto dentro do círculo que aparece na tela, seguindo as orientações.'

export const TEXTO_PROCESSANDO_DADOS = "Aguarde enquanto processamos seus dados.";
export const TEXTO_BOTAO_VOLTAR = "Voltar";
export const TEXTO_BOTAO_AVANCAR = "Avançar";
export const TEXTO_BOTAO_TENTAR_NOVAMENTE = "Tentar de Novo";

const TEXTO_BIOMETRIA_REALIZADA = "Reconhecimento facial realizado com sucesso."
const TEXTO_BIOMETRIA_NAO_REALIZADA = "Reconhecimento facial não realizado."
const TEXTO_BIOMETRIA_INDISPONIVEL = "Reconhecimento facial não disponível."
const TEXTO_HABILITE_ACESSO_CAMERA = "Habilite a permissão de acesso à câmera do seu dispositivo para continuar."

export const obterTextoRetornoBiometria = (serviceName) => {
  switch (serviceName) {
    case SERVICO_BIOMETRIA.DESBLOQUEIO_EMPRESTIMO_CONSIGNADO:
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'Siga para o botão <strong>Avançar</strong> e libere o benefício para novo empréstimo.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_TSE: {
          TITULO: TEXTO_BIOMETRIA_INDISPONIVEL,
          DESCRICAO: 'Não foi possível confirmar a identidade pelo reconhecimento facial.\
                        </br></br>Siga para o botão <strong>Login pelo Banco</strong> para acessar o \
                        banco online e liberar o benefício para novo empréstimo. </br></br>Caso queira \
                        apenas concluir o pedido, siga para <strong>Avançar</strong>. Esta opção não \
                        libera o benefício para novo empréstimo.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_SELO_BANCO: {
          TITULO: TEXTO_BIOMETRIA_INDISPONIVEL,
          DESCRICAO: 'Foi identificado <strong>Login pelo banco</strong> no gov.br. \
                        </br></br>Siga para o botão <strong>Avançar</strong> e libere o benefício para \
                        novo empréstimo.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Siga para o botão <strong>Tentar de Novo</strong> e repita os passos \
                        para liberar o benefício com reconhecimento facial.</br></br> Caso queira apenas \
                        concluir o pedido, siga para o botão <strong>Avançar</strong>. Esta opção não libera o \
                        benefício para novo empréstimo.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    case SERVICO_BIOMETRIA.PROVA_DE_VIDA:
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'Confira a situação da prova de vida.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: '',
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Siga para o botão <strong>Tentar de Novo</strong> e repita os passos \
                        para realizar a prova de vida com reconhecimento facial.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    case SERVICO_BIOMETRIA.DESBLOQUEIO_MENSALIDADE_ENTIDADE:
    case SERVICO_BIOMETRIA.ALTERAR_PAGAMENTO:
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'O reconhecimento facial garante mais segurança nas ações.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Não foi possível realizar seu reconhecimento facial.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    default: {
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'O reconhecimento facial garante mais segurança nas ações.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Não foi possível realizar seu reconhecimento facial.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    }
  }
}